<script>
import { heightReference } from '../../../mixins/mixinProps'
import mixinPoint from '../../../mixins/graphics/mixinPoint'
import mixinGraphic from '../../../mixins/graphics/mixinGraphic'
export default {
  name: 'vc-graphics-point',
  mixins: [heightReference, mixinPoint, mixinGraphic]
}
</script>
